/**
 * When enabled: do not redirect to /logout or clear tokens on API 401/403, workspace bootstrap
 * failures, context switch failures, etc. Helps trace bad endpoints during development.
 *
 * Still signs out when the context JWT is missing, malformed, or past exp (useTokenExpiration)
 * and when there is no context token on a route that requires it (AuthInitializer effect 2).
 *
 * - Default: ON in `import.meta.env.DEV`
 * - Force strict in dev: `VITE_RELAX_AUTO_LOGOUT=false`
 * - Force relaxed in prod builds (e.g. staging debug): `VITE_RELAX_AUTO_LOGOUT=true`
 */
export function isRelaxedAutoLogoutEnabled(): boolean {
  const explicit = import.meta.env.VITE_RELAX_AUTO_LOGOUT
  if (explicit === 'false' || explicit === '0') return false
  if (explicit === 'true' || explicit === '1') return true
  return import.meta.env.DEV === true
}
